// extracted by mini-css-extract-plugin
export default {"body":"CartSkeleton_body__uwDE5","cartRight":"CartSkeleton_cartRight__5b6b4","commonClass":"CartSkeleton_commonClass__0zQun","shimmer":"CartSkeleton_shimmer__FYLyB"};